<script setup lang="ts">
import { ref } from "vue";

import AdminView from "./components/AdminView.vue";
import AppHeader from "./components/AppHeader.vue";
import CasesView from "./components/CasesView.vue";
import ChatView from "./components/ChatView.vue";
import LoginView from "./components/LoginView.vue";
import UnansweredView from "./components/UnansweredView.vue";
import { token } from "./lib/session.js";

/**
 * No router in this app. The chat is kept alive behind the other views so switching
 * to the queue, a toimik or the admin panel never costs a conversation.
 */
const view = ref<"chat" | "unanswered" | "admin" | "cases">("chat");

/**
 * A request to start a fresh thread inside a toimik (D21).
 *
 * A counter rather than a bare id, because asking twice for the same toimik is a
 * normal thing to do: finish one thread, go back, start another. With a plain id the
 * second click changes nothing, the watcher never fires, and the user is left typing
 * into the conversation they thought they had just left.
 */
const chatCaseRequest = ref<{ caseId: string; n: number } | null>(null);
let requests = 0;

function openChatInCase(caseId: string): void {
  requests += 1;
  chatCaseRequest.value = { caseId, n: requests };
  view.value = "chat";
}
</script>

<template>
  <!-- There is no anonymous path: no token, no app (blueprint §10). -->
  <LoginView v-if="!token" />
  <template v-else>
    <AppHeader v-model:view="view" />
    <ChatView v-show="view === 'chat'" :case-request="chatCaseRequest" @cleared="chatCaseRequest = null" />
    <UnansweredView v-if="view === 'unanswered'" />
    <CasesView v-else-if="view === 'cases'" @open-chat="openChatInCase" />
    <AdminView v-else-if="view === 'admin'" />
  </template>
</template>
